import { IBounds } from './interaces';

export const findBounds = (
  items: Array<{ x: number; y: number }>
): IBounds | null => {
  if (items.length === 0) {
    return null;
  }

  const xs = items.map((p) => p.x);
  const ys = items.map((p) => p.y);

  return {
    minX: Math.min(...xs),
    maxX: Math.max(...xs),
    minY: Math.min(...ys),
    maxY: Math.max(...ys),
  };
};

export const getBlockWidth = (text: string, fontSize: number): number => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) return 73;

  context.font = `${fontSize}px Inter`;

  const lines = text.split('\n');
  let maxTextWidth = 0;

  for (const line of lines) {
    const textWidth = context.measureText(line).width;
    if (textWidth > maxTextWidth) {
      maxTextWidth = textWidth;
    }
  }

  const cellWidth = 73;
  const gap = 8;

  if (maxTextWidth <= cellWidth) return cellWidth;

  const cellsCount = Math.ceil((maxTextWidth + gap) / (cellWidth + gap));

  return cellsCount * cellWidth + (cellsCount - 1) * gap;
};

export const getBlockHeight = (text: string, fontSize: number): number => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (context) {
    context.font = `${fontSize}px Inter`;

    const lines = text.split('\n');
    let maxLineWidth = 0;

    for (const line of lines) {
      const lineWidth = context.measureText(line).width;
      if (lineWidth > maxLineWidth) {
        maxLineWidth = lineWidth;
      }
    }

    const textHeight = lines.length * 16;

    const cellHeight = 73;
    const gap = 8;

    if (textHeight <= cellHeight) return cellHeight;

    const cellsCount = Math.ceil(textHeight / (cellHeight + gap));

    return cellsCount * cellHeight + (cellsCount - 1) * gap;
  }

  return 73;
};
